// Kuro Products
export const UPDATE_COMPONENTS = 'UPDATE_COMPONENTS'
export const UPDATE_MONITORS = 'UPDATE_MONITORS'
export const UPDATE_ACCESSORIES = 'UPDATE_ACCESSORIES'
export const UPDATE_NETWORKING = 'UPDATE_NETWORKING'
export const UPDATE_EXTERNAL = 'UPDATE_EXTERNAL'
export const UPDATE_PRESETS = 'UPDATE_PRESETS'